import React from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { WhatsAppButton } from '../../components/feature/WhatsAppButton';
import { Button } from '../../components/base/Button';
import { Link } from 'react-router-dom';

const ListTimesharePage: React.FC = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/905XXXXXXXXX?text=Merhaba, devremülk ilanı vermek istiyorum.', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#0A1628] to-[#1a2d4d]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Devremülk İlanı Ver
          </h1>
          <p className="text-xl text-white/80 max-w-3xl">
            Devremülk hakkınızı satmak için bizimle iletişime geçin. Profesyonel ekibimiz size yardımcı olacaktır.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <div className="bg-white rounded-2xl border-2 border-[#D4AF37] p-12 text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-[#D4AF37]/10 rounded-full mx-auto mb-6">
              <i className="ri-customer-service-2-line text-4xl text-[#D4AF37]"></i>
            </div>
            
            <h2 className="text-3xl font-bold text-[#0A1628] mb-4">
              İlan Vermek İçin Bizimle İletişime Geçin
            </h2>
            
            <p className="text-lg text-[#6B7A90] mb-8 max-w-2xl mx-auto">
              Devremülk ilanlarınızı profesyonel bir şekilde yayınlamak için uzman ekibimiz size yardımcı olacaktır. 
              Aşağıdaki iletişim kanallarından bize ulaşabilirsiniz.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Button
                variant="primary"
                size="lg"
                onClick={handleWhatsAppClick}
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp ile İletişim
              </Button>
              
              <Link to="/iletisim">
                <Button
                  variant="secondary"
                  size="lg"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Telefon ile İletişim
                </Button>
              </Link>
            </div>

            <div className="bg-[#F7F9FC] rounded-xl p-6">
              <h3 className="text-lg font-semibold text-[#0A1628] mb-4">
                İlan Verme Süreci
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                <div className="flex gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0 font-bold">
                    1
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A1628] mb-1">İletişime Geçin</h4>
                    <p className="text-sm text-[#6B7A90]">WhatsApp veya telefon ile bize ulaşın</p>
                  </div>
                </div>
                
                <div className="flex gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0 font-bold">
                    2
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A1628] mb-1">Bilgi Paylaşın</h4>
                    <p className="text-sm text-[#6B7A90]">Devremülk detaylarınızı ekibimizle paylaşın</p>
                  </div>
                </div>
                
                <div className="flex gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0 font-bold">
                    3
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A1628] mb-1">İlan Yayınlansın</h4>
                    <p className="text-sm text-[#6B7A90]">İlanınız profesyonelce hazırlanıp yayınlanır</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-[#F7F9FC]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h2 className="text-3xl font-bold text-[#0A1628] text-center mb-12">
            Neden Bizimle Çalışmalısınız?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#0A1628] mb-3">
                Güvenilir Platform
              </h3>
              <p className="text-base text-[#6B7A90]">
                Tüm ilanlar doğrulanır ve profesyonelce hazırlanır
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mx-auto mb-4">
                <i className="ri-group-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#0A1628] mb-3">
                Geniş Kitle
              </h3>
              <p className="text-base text-[#6B7A90]">
                Binlerce potansiyel alıcıya ulaşın
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mx-auto mb-4">
                <i className="ri-customer-service-2-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#0A1628] mb-3">
                Profesyonel Destek
              </h3>
              <p className="text-base text-[#6B7A90]">
                Uzman ekibimiz her adımda yanınızda
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ListTimesharePage;
